import React, { useState } from "react";
import "../../assets/styles/createproduct.css";
import { IoCloudUploadOutline } from "react-icons/io5";
import { RiDeleteBin5Line } from "react-icons/ri";
import { TiTick } from "react-icons/ti";
import Modal from "../../components/common/modal";
import { useNavigate } from "react-router-dom";

const CreateProducts = () => {
  const navigate = useNavigate();
  const [imagePreview, setImagePreview] = useState();
  // "http://i.pravatar.cc/500?img=7"

  const readURL = (input) => {
    if (input.files && input.files[0]) {
      const reader = new FileReader();
      reader.onload = function (e) {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(input.files[0]);
    }
  };

  const nav = useNavigate();

  const [bulkImages, setBulkImages] = useState([]);
  const [uploadSave, setUploadSave] = useState(false);
  const [upload, setUload] = useState(false);
  const [bulkVideos, setBulkVideos] = useState([]);
  const [videoUrl, setVideoUrl] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [fileType, setFileType] = useState("stone");
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [selectedVideoIndex, setSelectedVideoIndex] = useState(null);
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [tags, setTags] = useState([]);
  const [tagInput, setTagInput] = useState("");
  const [isTagDropdownOpen, setIsTagDropdownOpen] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [isFileDragging, setIsFileDragging] = useState(false);

  const availableTags = [
    "Design",
    "Development",
    "Marketing",
    "Sales",
    "Support",
    "Engineering",
    "Product",
    "Management",
    "Finance",
    "HR",
  ];

  const getEmbedUrl = (url) => {
    if (
      typeof url === "string" &&
      (url.includes("youtube.com") || url.includes("youtu.be"))
    ) {
      let videoId = "";
      if (url.includes("watch?v=")) {
        videoId = url.split("watch?v=")[1].split("&")[0];
      } else if (url.includes("youtu.be/")) {
        videoId = url.split("youtu.be/")[1].split("?")[0];
      }
      return `https://www.youtube.com/embed/${videoId}`;
    }
    return null;
  };

  const handleBulkImageChange = (e) => {
    if (e.target.files) {
      const files = Array.from(e.target.files);
      const newImages = files.map((file) => URL.createObjectURL(file));
      setBulkImages((prev) => [...prev, ...newImages]);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const files = Array.from(e.dataTransfer.files);
    const imageFiles = files.filter((file) => file.type.startsWith("image/"));
    const newImages = imageFiles.map((file) => URL.createObjectURL(file));
    setBulkImages((prev) => [...prev, ...newImages]);
  };

  const handleAddVideoUrl = (e) => {
    e.preventDefault();
    if (videoUrl.trim()) {
      setBulkVideos((prev) => [...prev, videoUrl]);
      setVideoUrl("");
    }
  };

  const handleBulkVideoChange = (e) => {
    if (e.target.files) {
      const files = Array.from(e.target.files);
      const newVideos = files.map((file) => URL.createObjectURL(file));
      setBulkVideos((prev) => [...prev, ...newVideos]);
    }
  };
  const uploadImages = () => {
    setUload(true);
  };

  const saveData = () => {
    setUploadSave(true);
    navigate("/products");
  };
  const handleDeleteImage = (indexToDelete) => {
    setBulkImages((prev) => prev.filter((_, index) => index !== indexToDelete));
  };

  const handleImageClick = (img, index) => {
    setSelectedImage(img);
    setSelectedImageIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
    setSelectedImageIndex(null);
  };

  const handleVideoClick = (vid, index) => {
    setSelectedVideo(vid);
    setSelectedVideoIndex(index);
    setIsVideoModalOpen(true);
  };

  const closeVideoModal = () => {
    setIsVideoModalOpen(false);
    setSelectedVideo(null);
    setSelectedVideoIndex(null);
  };

  const handleDeleteVideo = (indexToDelete) => {
    setBulkVideos((prev) => prev.filter((_, index) => index !== indexToDelete));
  };

  const handleAddTag = (e) => {
    e.preventDefault();
    if (tagInput.trim() && !tags.includes(tagInput.trim())) {
      setTags((prev) => [...prev, tagInput.trim()]);
      setTagInput("");
    }
  };

  const handleToggleTag = (tag) => {
    if (tags.includes(tag)) {
      setTags((prev) => prev.filter((t) => t !== tag));
    } else {
      setTags((prev) => [...prev, tag]);
    }
  };

  const handleRemoveTag = (tagToRemove) => {
    setTags((prev) => prev.filter((tag) => tag !== tagToRemove));
  };

  const handleFileDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsFileDragging(true);
  };

  const handleFileDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsFileDragging(false);
  };

  const handleFileDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsFileDragging(false);

    const files = Array.from(e.dataTransfer.files);
    const validFiles = files.filter(
      (file) =>
        file.type === "application/pdf" ||
        file.type === "application/msword" ||
        file.type ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    );

    if (validFiles.length > 0) {
      const newFiles = validFiles.map((file, index) => ({
        id: Date.now() + index,
        name: file.name,
        size: (file.size / (1024 * 1024)).toFixed(2),
        progress: Math.floor(Math.random() * 30) + 70,
        status: "uploading",
        timeLeft: Math.floor(Math.random() * 60) + 10,
      }));
      setUploadedFiles((prev) => [...prev, ...newFiles]);
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files) {
      const files = Array.from(e.target.files);
      const newFiles = files.map((file, index) => ({
        id: Date.now() + index,
        name: file.name,
        size: (file.size / (1024 * 1024)).toFixed(2),
        progress: Math.floor(Math.random() * 30) + 70,
        status: "uploading",
        timeLeft: Math.floor(Math.random() * 60) + 10,
      }));
      setUploadedFiles((prev) => [...prev, ...newFiles]);
    }
  };

  const handleRemoveFile = (id) => {
    setUploadedFiles((prev) => prev.filter((file) => file.id !== id));
  };

  const handleRetryFile = (id) => {
    setUploadedFiles((prev) =>
      prev.map((file) =>
        file.id === id ? { ...file, status: "uploading", progress: 0 } : file,
      ),
    );
  };

  const macrofamilyOptions = ["Family 1", "Family 2"];
  const categoryOptions = ["Category 1", "Category 2"];
  const industryOptions = ["Industry 1", "Industry 2"];

  return (
    <>
      <div className="body">
        <div className="inputFields">
          <form action="">
            <div className="form-header">
              <div
                className="text-inputs"
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                <div>
                  <label htmlFor="">Title</label>
                  <input
                    type="text"
                    placeholder="Text here..."
                    style={{ width: "100%", marginTop: "10px" }}
                  />
                </div>
                <div>
                  <label htmlFor="" className="label">
                    Subtitle
                  </label>
                  <input
                    type="text"
                    placeholder="Text here..."
                    style={{ width: "100%", marginTop: "10px" }}
                  />
                </div>
              </div>
              <div className="image-upload-section">
                <div className="avatar-upload" style={{ margin: "0" }}>
                  <div className="avatar-edit">
                    <input
                      type="file"
                      id="imageUpload"
                      accept=".png, .jpg, .jpeg"
                      onChange={(e) => readURL(e.target)}
                    />
                    <label htmlFor="imageUpload"></label>
                  </div>
                  <div className="avatar-preview">
                    <div
                      id="imagePreview"
                      style={{ backgroundImage: `url(${imagePreview})` }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>

            <label htmlFor="" className="description">
              Description
            </label>
            <br />
            <textarea placeholder="Type here..." rows="5"></textarea>
          </form>

          <div class="select-container">
            <form action="#" className="form">
              <label>Select Choices</label>
              <select name="" id="family">
                <option value="">---Macro Family---</option>
                {macrofamilyOptions.map((option, index) => (
                  <option key={index} value={option}>
                    {option}
                  </option>
                ))}
              </select>
              <select name="" id="category">
                <option value="">---Category---</option>
                {categoryOptions.map((option, index) => (
                  <option key={index} value={option}>
                    {option}
                  </option>
                ))}
              </select>
              <select name="" id="industry">
                <option value="">---Industry---</option>
                {industryOptions.map((option, index) => (
                  <option key={index} value={option}>
                    {option}
                  </option>
                ))}
              </select>

              <div className="modal-tags-container">
                <div style={{ marginBottom: "20px" }}>
                  <label htmlFor="tagInput" style={{ textAlign: "left" }}>
                    Select Tags
                  </label>

                  <div className="tag-selector-wrapper">
                    <div className="tag-dropdown-wrapper">
                      <div
                        className="tag-dropdown-select"
                        onClick={() => setIsTagDropdownOpen(!isTagDropdownOpen)}
                      >
                        <span>
                          {tags.length > 0
                            ? `${tags.length} tag(s) selected`
                            : "Select tags..."}
                        </span>
                        <span className="dropdown-arrow">
                          {isTagDropdownOpen ? "▲" : "▼"}
                        </span>
                      </div>

                      {isTagDropdownOpen && (
                        <div className="tag-dropdown-menu">
                          {availableTags.map((tag, index) => (
                            <label key={index} className="tag-dropdown-item">
                              <input
                                type="checkbox"
                                checked={tags.includes(tag)}
                                onChange={() => handleToggleTag(tag)}
                              />
                              <span>{tag}</span>
                            </label>
                          ))}
                        </div>
                      )}
                    </div>

                    {tags.length > 0 && (
                      <div className="tags-inline">
                        <ul className="tagLists">
                          {tags.map((tag, index) => (
                            <li key={index}>
                              <TiTick style={{ marginRight: "5px" }} />
                              {tag}
                              <button
                                className="remove-tag"
                                aria-label="Remove tag"
                                onClick={() => handleRemoveTag(tag)}
                                type="button"
                              >
                                ×
                              </button>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div className="uploadSection">
          <div className="UploadImages">
            <div className="bulkThumbnail">
              <h3>Bulk Image Upload</h3>
              <div
                className={`bulkUpload ${isDragging ? "dragging" : ""}`}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                style={{
                  border: isDragging
                    ? "2px dashed #0A4DA2"
                    : "2px dashed transparent",
                  backgroundColor: isDragging ? "#f0f7ff" : "transparent",
                  transition: "all 0.3s ease",
                }}
              >
                <div className="bulk-images-grid">
                  {bulkImages.map((img, index) => (
                    <div key={index} className="bulk-image-card">
                      <img
                        src={img}
                        alt={`upload-${index}`}
                        onClick={() => handleImageClick(img, index)}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  ))}
                  <div
                    className="add-new-card"
                    onClick={() =>
                      document.getElementById("bulkImageInput").click()
                    }
                  >
                    <span
                      style={{
                        textAlign: "center",
                        fontSize: "clamp(0.5rem, 2.5vw, 0.8rem)",
                      }}
                    >
                      Drag & Drop or Click to Upload
                    </span>
                  </div>
                </div>
                <input
                  type="file"
                  multiple
                  id="bulkImageInput"
                  style={{ display: "none" }}
                  onChange={handleBulkImageChange}
                />
                {/* <button className="addBtn" onClick={uploadImages}>
                  {" "}
                  <IoCloudUploadOutline style={{ marginRight: "8px" }} /> Upload
                </button> */}
              </div>
            </div>
          </div>

          <div className="fileUpload">
            <div className="upload-header">
              <h3>Upload File</h3>
            </div>

            <div className="upArea">
              <div
                className="upload-area"
                onClick={() => document.getElementById("fileInput").click()}
                onDragOver={handleFileDragOver}
                onDragLeave={handleFileDragLeave}
                onDrop={handleFileDrop}
                style={{
                  border: isFileDragging
                    ? "2px dashed #0A4DA2"
                    : "2px dashed #ddd",
                  backgroundColor: isFileDragging ? "#f0f7ff" : "transparent",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                }}
              >
                <div className="plus-icon">+</div>
                <p>Click or drag files to upload</p>
                <p className="file-info">
                  It must be .pdf or .docs file(20MB Max)
                </p>
              </div>

              <input
                type="file"
                id="fileInput"
                accept=".pdf,.doc,.docx"
                multiple
                onChange={handleFileChange}
                style={{ display: "none" }}
              />

              {uploadedFiles.length > 0 && (
                <div className="file-list">
                  {uploadedFiles.map((file) => (
                    <div key={file.id} className="file-item">
                      <div className="file-info-row">
                        <div className="file-icon">📄</div>
                        <div className="file-details">
                          <div className="file-name">{file.name}</div>
                          <div className="file-meta">
                            <span className="file-size">{file.size} mb</span>
                            {file.status === "uploading" && (
                              <>
                                <span className="file-progress">
                                  {file.progress}%
                                </span>
                                <span className="file-time">
                                  {file.timeLeft} sec left
                                </span>
                              </>
                            )}
                            {file.status === "uploaded" && (
                              <span className="file-status-text">Uploaded</span>
                            )}
                            {file.status === "failed" && (
                              <span className="file-status-text error">
                                Upload Failed
                              </span>
                            )}
                          </div>
                          {file.status === "uploading" && (
                            <div className="progress-bar">
                              <div
                                className="progress-fill"
                                style={{ width: `${file.progress}%` }}
                              ></div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="file-actions">
                        {file.status === "failed" && (
                          <button
                            className="retry-btn"
                            onClick={() => handleRetryFile(file.id)}
                          >
                            ↻
                          </button>
                        )}
                        <button
                          className="delete-btn"
                          onClick={() => handleRemoveFile(file.id)}
                        >
                          <RiDeleteBin5Line />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            {/* <div className="button-group">
              <button className="cancel-btn">Cancel</button>
              <button className="save-btn" onClick={uploadImages}>
                Save
              </button>
            </div> */}
          </div>
        </div>
        <div className="videoContainer">
          <h3 style={{ borderBottom: "1px solid #f3f4f6" }}>
            Product Video Upload
          </h3>
          <div className="bulkUpload">
            <div className="url-input-container">
              <input
                type="text"
                placeholder="Enter Video URL"
                value={videoUrl}
                onChange={(e) => setVideoUrl(e.target.value)}
              />
              <button onClick={handleAddVideoUrl} className="commonButton">
                Add URL
              </button>
            </div>
            <div className="bulk-video-grid">
              {bulkVideos.map((vid, index) => {
                const embedUrl = getEmbedUrl(vid);
                return (
                  <div
                    key={index}
                    className="bulk-video-card"
                    style={{ position: "relative" }}
                  >
                    {embedUrl ? (
                      <iframe
                        width="100%"
                        height="100%"
                        src={embedUrl}
                        title={`video-${index}`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        style={{ pointerEvents: "none" }}
                      ></iframe>
                    ) : (
                      <video
                        width="100%"
                        height="100%"
                        key={vid}
                        style={{ pointerEvents: "none" }}
                      >
                        <source src={vid} type="video/mp4" />
                      </video>
                    )}
                    <div
                      onClick={() => handleVideoClick(vid, index)}
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        cursor: "pointer",
                        backgroundColor: "transparent",
                      }}
                      title="Click to preview"
                    ></div>
                  </div>
                );
              })}
            </div>
            <input
              type="file"
              multiple
              id="bulkVideoInput"
              style={{ display: "none" }}
              onChange={handleBulkVideoChange}
            />
          </div>
        </div>

        <div
          style={{
            display: "flex",
            gap: "10px",
            justifyContent: "flex-end",
            marginTop: "20px",
          }}
        >
          <button type="button" className="cancelBtn">
            Cancel
          </button>
          <button onClick={saveData} type="submit" className="commonButton">
            Save
          </button>
        </div>
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        className="image-preview-modal"
      >
        <div className="image-modal-wrapper">
          <img
            src={selectedImage}
            alt="Preview"
            className="modal-preview-image"
          />
          <button
            className="modal-delete-btn"
            onClick={() => {
              handleDeleteImage(selectedImageIndex);
              closeModal();
            }}
            title="Delete image"
          >
            <RiDeleteBin5Line />
          </button>
        </div>
      </Modal>

      <Modal
        isOpen={isVideoModalOpen}
        onClose={closeVideoModal}
        className="video-preview-modal"
      >
        <div className="video-modal-wrapper" style={{ position: "relative" }}>
          <button
            className="modal-delete-btn"
            onClick={() => {
              handleDeleteVideo(selectedVideoIndex);
              closeVideoModal();
            }}
            title="Delete video"
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              zIndex: 10,
            }}
          >
            <RiDeleteBin5Line />
          </button>
          {selectedVideo &&
            (() => {
              const embedUrl = getEmbedUrl(selectedVideo);
              return embedUrl ? (
                <iframe
                  width="100%"
                  height="500px"
                  src={embedUrl}
                  title="Video Preview"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              ) : (
                <video width="100%" height="500px" controls>
                  <source src={selectedVideo} type="video/mp4" />
                </video>
              );
            })()}
        </div>
      </Modal>
    </>
  );
};

export default CreateProducts;
